import { render, staticRenderFns } from "./Listujipetik.vue?vue&type=template&id=0ff7dc2a"
import script from "./Listujipetik.vue?vue&type=script&lang=js"
export * from "./Listujipetik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports